import {
    InputWysiwygComponent,
    validatorWysiwygRequired,
} from './../../../../../shared/components/inputs/input-wysiwyg/input-wysiwyg.component';
import { Component, OnInit, viewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { fb, isAllowed, router } from '../../../../../shared/shared.global-service';
import { Validators } from '@angular/forms';
import { ServicePatternsDocumentPageStore } from './services-patterns-document-page.store';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServicePatternDocumentCreateInput,
} from '@libs/types/src/services/input-type/services/service-pattern.create-input';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { dateify, dateifyOrNow } from '../../../../../shared/helpers/date.helper';
import { BreadcrumbService } from 'xng-breadcrumb';
import {
    ServicePatternDocumentUpdateInput,
} from '@libs/types/src/services/input-type/services/service-pattern.update-input';
import { BreadcrumbsEnum } from 'packages/client/src/app/modules/shared/models/breadcrumbs.enum';
import {
    servicePatternDocumentUsageEnumOptions,
} from '@libs/types/src/services/enum/service-pattern-document-usage.enum';
import { CardComponent } from '../../../../../../components/kit/card/card.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';
import {
    WysiwygPlaceholderInfoComponent
} from '../../../../../../components/kit/wysiwyg/wysiwyg-placeholder-info/wysiwyg-placeholder-info.component';
import { WysiwygPlaceholderGroupEnum } from '@libs/types/src/common/enum/wysiwyg-placeholder.enum';

@Component({
    selector: 'app-services-patterns-document-page',
    templateUrl: './services-patterns-document-page.component.html',
    styleUrl: './services-patterns-document-page.component.scss',
    providers: [ServicePatternsDocumentPageStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardComponent,
        SelectInputComponent,
        TextInputComponent,
        DateInputComponent,
        TranslatePipe,
        InputWysiwygComponent,
        ActionButtonsComponent,
        WysiwygPlaceholderInfoComponent,
    ],
})
export class ServicesPatternsDocumentPageComponent extends SubscriptionComponent implements OnInit {

    protected readonly store = inject(ServicePatternsDocumentPageStore);
    protected readonly route = inject(ActivatedRoute);
    private readonly breadcrumbs = inject(BreadcrumbService);

    public readonly wysiwyg = viewChild<InputWysiwygComponent>(InputWysiwygComponent);

    protected form = fb.group({
        usage: fb.control<string | null>(null, Validators.required),
        name: fb.control<string>('', Validators.required),
        validFrom: fb.control<Date>(new Date(), Validators.required),
        validTo: fb.control<Date | null>(null),
        note: fb.control<string>(''),
        content: fb.control<string>('', validatorWysiwygRequired),
    });

    protected title = 'service.patterns.document.add.title';

    private documentId: number | null = null;

    constructor() {
        super();
        this.subs.push(
            this.store.routeParam.patternId.subscribe((it) => {
                this.documentId = Number(it) || null;
                if (this.documentId) {
                    this.store.api.getServicePatterns(FilterBuilder.singleItem({ id: this.documentId }));
                    this.title = 'service.patterns.document.edit.title';
                }
            }),
            this.store.structure$.subscribe((it) => {
                if (it) {
                    this.breadcrumbs.set(`@${BreadcrumbsEnum.ServicePatternsDocuments}`, `${BreadcrumbsEnum.ServicePatternsDocuments}|${it?.id}`);
                    this.form.patchValue({
                        ...it,
                        validFrom: dateifyOrNow(it.validFrom),
                        validTo: dateify(it.validTo),
                    });
                }
            }),
        );
        this.store.doOnActions(
            () => {
                this.wysiwyg()?.resetBackupValues();
                router.navigate(['../../'], { relativeTo: this.route });
            },
            'createServicePatternDocument',
            'updateServicePatternDocument',
        );
        this.store.registerSuccessMessage('createServicePatternDocument', 'common.created');
        this.store.registerSuccessMessage('updateServicePatternDocument', 'common.updated');
    }

    ngOnInit(): void {
        if (!isAllowed['service.update']()) {
            this.form.disable();
        }
    }

    async submit(): Promise<void> {
        if (isInvalid(this.form)) {
            return;
        }
        const values = this.form.getRawValue();
        const base = {
            ...values,
            validFrom: values.validFrom?.toISOString(),
            validTo: values.validTo?.toISOString() || null,
        };


        if (this.documentId) {
            const data = base as ServicePatternDocumentUpdateInput;
            data.id = this.documentId;
            this.store.api.updateServicePatternDocument(data);
        } else {
            const data = base as ServicePatternDocumentCreateInput;
            data.serviceId = Number(this.store.routeParam.serviceId.value);
            this.store.api.createServicePatternDocument(data);
        }
    }

    protected readonly servicePatternUsageEnumOptions = servicePatternDocumentUsageEnumOptions;
    protected readonly WysiwygPlaceholderGroupEnum = WysiwygPlaceholderGroupEnum;
}
